const accessibilityTags = {
  todayStudyNameID: 'today-study-title',
  profileButtonID: 'navBar-profile-button',
  messageButtonID: 'navBar-message-button',
  chatTextFieldID: 'chat-message-textfield',
  chatSendButtonID: 'chat-send-button',
  confirmDialogYesID: 'confirmDialog-yes-button',
  confirmDialogNoID: 'confirmDialog-no-button',
  encouragementEmojiID: 'component-encouragement-label',
  timeSelectorID: 'form-time-selector',
  timePickerSelectedID: 'form-time-selected',
  confirmButtonID: 'form-timeConfirm-button',
  earnTabID: 'rewards-earnTab-button',
  redeemTabID: 'rewards-redeemTab-button',
  activeTabID: 'studies-activeTab-button',
  pastTabID: 'studies-pastTab-button',
  favoritesTabID: 'studies-favoritesTab-button',
  joinTabID: 'join-joinTab-button',
  createTabID: 'join-createTab-button',
  loadingID: 'form-loading-graphic',
  pointsContainerID: 'navBar-points-button',
  progressionButtonID: 'form-progression-button',
  dateID: 'form-date-selector',
  iosDateSaveID: 'form-dateSave-button',
  iosDateCancelID: 'form-dateCancel-button',
  selectorID: 'form-select-selector',
  textfieldID: 'form-form-textfield',
  timeID: 'form-time-selector',
  sliderID: 'form-slider-selector',
  formWearableTextfieldID: 'form-wearable-textfield',
  todayButtonID: 'navBar-today-button',
  joinButtonID: 'navBar-join-button',
  rewardsButtonID: 'navBar-rewards-button',
  myDataButtonID: 'navBar-myData-button',
  myStudiesButtonID: 'navBar-myStudies-button',
  startCreatingButtonID: 'join-startCreating-button',
  forgotPasswordEmailFieldID: 'forgotPassword-email-textfield',
  continueButtonID: 'forgotPassword-continue-button',
  forgotPasswordReturnButtonID: 'forgotPassword-return-button',
  forgotPasswordTitleID: 'forgotPassword-forgotPassword-title',
  loginEmailID: 'login-email-textfield',
  loginPasswordID: 'login-password-textfield',
  loginButtonID: 'login-login-button',
  loginForgotPasswordID: 'login-forgotPassword-button',
  loginSignUpButtonID: 'login-signUp-button',
  loginWelcomeID: 'login-welcome-title',
  errorLabelID: 'login-error-label',
  resendButtonID: 'emailSent-resend-button',
  tryAnotherEmailID: 'emailSent-tryAgain-button',
  emailSentReturnButtonID: 'emailSent-return-button',
  emailVerificationLabelID: 'signUp-emailVerification-label',
  signUpEmailID: 'signUp-email-textfield',
  signUpFirstNameID: 'signUp-firstName-textfield',
  signUpLastNameID: 'signUp-lastName-textfield',
  signUpPhoneID: 'signUp-phone-textfield',
  signUpPasswordID: 'signUp-password-textfield',
  signUpConfirmPasswordID: 'signUp-confirmPassword-textfield',
  signUpConfirmButtonID: 'signUp-confirm-button',
  signUpReturnButtonID: 'signUp-return-button',
  signUpWelcomeID: 'signUp-welcome-title',
  signUpAgreeID: 'signUp-agreeToTerms-checkbox',
  deleteAccountButtonID: 'profile-deleteAccount-button',
  deleteAccountPasswordID: 'profile-deleteAccountPassword-textfield',
  firstNameFieldID: 'profile-firstName-textfield',
  lastNameFieldID: 'profile-lastName-textfield',
  emailFieldID: 'profile-email-textfield',
  currentPasswordFieldID: 'profile-currentPassword-textfield',
  newPasswordFieldID: 'profile-newPassword-textfield',
  confirmPasswordFieldID: 'profile-confirmPassword-textfield',
  birthdayDateFieldID: 'profile-birthday-selector',
  stateFieldID: 'profile-state-selector',
  phoneFieldID: 'profile-phone-textfield',
  saveButtonID: 'profile-save-button',
  textMessagesLabelID: 'profile-phoneMessages-label',
  textMessagesToggleID: 'profile-phoneMessages-selector',
  textNotificationsToggleID: 'profile-phoneStudyNotifications-selector',
  settingsNameID: 'profile-name-button',
  settingsEmailID: 'profile-email-button',
  settingsPasswordID: 'profile-password-button',
  settingsBirthdayID: 'profile-birthday-button',
  settingsStateID: 'profile-state-button',
  settingsUnitSystemID: 'profile-unitSystem-button',
  settingsBiologicalSexID: 'profile-biologicalSex-button',
  settingsPhoneID: 'profile-phone-button',
  settingsWearableID: 'profile-wearable-button',
  settingsPrivacyID: 'profile-privacy-button',
  settingsLogOutID: 'profile-logOut-button',
  settingsNameLabelID: 'profile-name-label',
  settingsEmailLabelID: 'profile-email-label',
  startStudyID: 'studies-startStudy-button',
  noStudiesID: 'studies-noStudies-label',
  studyCardID: 'studies-studyCard-button',
  studyFavoriteIconID: 'studies-studyCardFavorite-button',
  studyNameID: 'studies-studyName-title',
  studySummaryID: 'studies-studySummary-label',
  studyDescriptionID: 'studies-studyDescription-label',
  studyDurationID: 'studies-studyDuration-label',
  studyDaysLoggedID: 'studies-studyDaysLogged-label',
  studyStartDateID: 'studies-studyStartDate-label',
  studyEndDateID: 'studies-studyEndDate-label',
  settingsIconID: 'studies-settings-button',
  resultsCompareID: 'studies-resultsCompare-graphic',
  compareChartID: 'studies-compareChart-graphic',
  qaGraphicID: 'studies-qa-graphic',
  notificationTimeID: 'studies-notificationTimeSetting-button',
  notificationTimeSubmitID: 'studies-notificationTimeSubmit-button',
  restartStudyID: 'studies-restartStudy-button',
  deleteStudyID: 'studies-deleteStudy-button',
  genericCardID: 'studies-genericCard-graphic',
  welcomeLabelID: 'today-welcome-label',
  dayStreakID: 'today-dayStreak-label',
  getStartedID: 'signUp-getStarted-button',
  signatureFieldID: 'form-signature-field',
  signatureClearButtonID: 'form-signatureClear-button',
  formSubtitleButtonID: 'form-subtitle-button',
  uploadImageButtonID: 'form-upload-button',
  takeImageID: 'form-takeImage-button',
  googleFitButtonID: 'data-googleFit-button',
  healthConnectButtonID: 'data-healthConnect-button',
  fitbitButtonID: 'data-fitbit-button',
  garminButtonID: 'data-garmin-button',
  myDataEllipsisID: 'data-ellipsis-button',
  deviceDataSyncID: 'data-synchronize-button'
};

export default accessibilityTags;
